import React, { createContext, useState, useContext } from 'react';

const UploadContext = createContext();

export const UploadProvider = ({ children }) => {
  const [uploadState, setUploadState] = useState({
    file: null,
    uploading: false,
    uploadProgress: 0,
    message: "",
    showPanel: false,
    failedUploads: [],
    uploadStatus: null
  });

  return (
    <UploadContext.Provider value={{ uploadState, setUploadState }}>
      {children}
    </UploadContext.Provider>
  );
};

export const useUpload = () => {
  return useContext(UploadContext);
};